module.exports = __webpack_public_path__ + "img/09.55c5621a.jpg";